module.exports = __webpack_public_path__ + "static/visual_2_1_eg-72d2752053ffa9f045f88e753b4e91ab.png";